export default __webpack_public_path__ + "static/media/hippo_wating.64ddf625.png";